import { extend, localize } from "vee-validate";
// let moment = require("jalali-moment");

import {
  confirmed as rule_confirmed,
  regex as rule_regex,
  between as rule_between,
  alpha as rule_alpha,
  integer as rule_integer,
  digits as rule_digits,
  alpha_dash as rule_alpha_dash,
  alpha_num as rule_alpha_num,
  length as rule_length,  
} from "vee-validate/dist/rules";

// eslint-disable-next-line object-curly-newline
import {
  validatorPositive,
  validatorUrlValidator,
  validatorPassword,
  validatorCreditCard,
  validatorMobile,
  validatorEmail,
  validatorMobileEmail,
  validatorNotArabic,
  validatorTotalPersian
} from "./validators";

// ////////////////////////////////////////////////////////
// General
// ////////////////////////////////////////////////////////

// export const email = extend('email', rule_email)

// export const min = extend('min', rule_min)

// export const confirmed = extend('confirmed', rule_confirmed)

export const regex = extend("regex", rule_regex);

export const between = extend("between", rule_between);

export const alpha = extend("alpha", rule_alpha);

export const integer = extend("integer", rule_integer);

export const digits = extend("digits", rule_digits);

export const alphaDash = extend("alpha-dash", rule_alpha_dash);

export const alphaNum = extend("alpha-num", rule_alpha_num);

export const length = extend("length", rule_length); 

export const positive = extend("positive", {
  validate: validatorPositive,
  message: "لطفا یک عدد مثبت انتخاب کنید!",
});

export const min = extend("min", {
  validate(value, args) {
    if (value.length < args) {
      return `تعداد کاراکتر نباید کمتر از ${args} رقم باشد`;
    } else {
      return true;
    }
  },
});
export const required = extend("required", {
  validate(value) {
    if (Array.isArray(value)) {
      if (value.length == 0) {
        return "فیلد ضروری است";
      } else {
        return true;
      }
    } else {
      if (!value) {
        return "فیلد ضروری است";
      } else {
        return true;
      }
    }
  },
  computesRequired: true,
});
export const confirmed = extend("confirmed", {
  validate(value, args) {
    if (value !== args[0]) {
      return "تایید رمز عبور با رمز عبور یکی نمی باشند";
    } else {
      return true;
    }
  },
  computesRequired: true,
});
// export const afterDate = extend("afterDate", {
//   validate(value, args) {
//     if (value && args[0]) {
//       let val1 = JSON.stringify(value);
//       let val2 = JSON.stringify(args[0]);

//       let first = moment(val1).locale("fa");
//       let second = moment(val2).locale("fa");
//       let diffTime = first.diff(second, "seconds");
//       if (diffTime < 0) {
//         return `تاریخ وارد شده باید بزرگتر از (${args[1]}) باشد`;
//       } else {
//         return true;
//       }
//     } else {
//       return true;
//     }
//   },
//   computesRequired: true,
// });
export const oldpassword = extend("oldpassword", {
  validate(value, args) {
    if (value === args[0]) {
      return "رمز عبور جدید نباید با رمز عبور قبلی یکی باشد.";
    } else {
      return true;
    }
  },
  computesRequired: true,
});

export const credit = extend("credit-card", {
  validate: validatorCreditCard,
  message: "It is not valid credit card!",
});

export const password = extend("password", {
  validate: validatorPassword,
  message:
    "رمز عبور شما باید با حروف لاتین و شامل حداقل یک حرف بزرگ, یک حرف کوچک, عدد و یکی از نمادهای (#?!@$%^&*-) باشد",
});
export const email = extend("email", {
  validate: validatorEmail,
  message: "ایمیل وارد شده صحیح نمی باشد.",
});
export const notArabic = extend("notArabic", {
  validate: validatorNotArabic,
  message: "کاراکترها نباید فارسی باشد",
});
export const totalPerisan = extend("totalPerisan", {
  validate: validatorTotalPersian,
  message: "کاراکترها باید فارسی باشد",
});
export const mobile = extend("mobile", {
  validate: validatorMobile,
  message: "شماره همراه وارد شده صحیح نمی باشد.",
});

export const url = extend("url", {
  validate: validatorUrlValidator,
  message: "URL is invalid",
});
export const mobileEmail = extend("mobileEmail", {
  validate: validatorMobileEmail,
  message: "شماره یا ایمیل وارد شده صحیح نمی باشد.",
});

// Install English and Arabic localizations.

// ////////////////////////////////////////////////////////
// NOTE:
// Quasar validation for reference only
// Remove this note once development is finished and make sure to
// to convert all of them in veevalidate version
// ////////////////////////////////////////////////////////

// export const required = (val) => {
//   return (val && val.length > 0) || '*Field is required'
// }

// export const required_obj = (obj) => {
//   if (obj === null || obj === undefined) return '*Field is required'
//   return (Object.entries(obj).length > 0 && obj.constructor === Object) || '*Field is required'
// }

// export const no_blank_spaces_arr = (arr) => {
//   return arr.every(val => (val.trim() && val.trim().length > 0)) || 'Blank Spaces are not allowed'
// }

// export const url = val => {
//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // Used
//   // https://stackoverflow.com/questions/4314741/url-regex-validation

//   // Other
//   // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
//   // https://www.w3resource.com/javascript-exercises/javascript-regexp-exercise-9.php
//   // https://www.geeksforgeeks.org/how-to-validate-url-using-regular-expression-in-javascript/

//   /* eslint-disable no-useless-escape */
//   const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
//   /* eslint-enable no-useless-escape */
//   return re.test(val) || 'URL is invalid'
// }

// export const date = val => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // https://github.com/quasarframework/quasar/blob/dev/ui/src/utils/patterns.js
//   return /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(val) || 'Date is invalid'
// }

// export const max = (val, max) => {

//   // If blank return
//   if (val === undefined || val === null) return true

//   return val.length <= max || `More than ${max} characters are not allowed`
// }

// export const max_arr = (val, max) => {
//   return val.length <= max || `More than ${max} values are not allowed`
// }

// export const min = (val, min) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   return val.length >= min || `Minimum ${min} characters are required`
// }

// export const num_range = (val, min, max) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   const msg = 'Value is invalid'
//   if (min === null) return val <= max || msg
//   else if (max === null) return val >= min || msg
//   else return (val >= min && val <= max) || msg
// }
